import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography } from '@mui/material';
import axios from 'axios';
import { CONFIG } from '../config';

function Confirmar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state?.email || '');
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!email.trim()) newErrors.email = true;
    if (!code.trim()) newErrors.code = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setIsLoading(true);
    try {
      const res = await axios.post(
        CONFIG.BACKEND_URL + '/backend/confirmuser',
        { email: email.trim(), code: code.trim() }
      );
      if (res.data?.code === 200) {
        alert('Cuenta verificada. Ya puedes iniciar sesión.');
        navigate('/login');
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        'No se pudo verificar el código.';
      alert('Error: ' + msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex animation-container bg">
      <div className="m-auto box-form">
        <Typography variant="h5" gutterBottom>
          Verificar correo
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Revisa tu correo y escribe el código de verificación que te enviamos.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 400 }}>
          <TextField
            fullWidth
            label="Correo electrónico"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email ? 'Requerido' : ''}
            sx={{ mb: 2 }}
            disabled={isLoading}
          />
          <TextField
            fullWidth
            label="Código de verificación"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            error={!!errors.code}
            helperText={errors.code ? 'Requerido' : ''}
            sx={{ mb: 2 }}
            disabled={isLoading}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
          >
            {isLoading ? 'Verificando...' : 'Verificar'}
          </Button>
          <Typography sx={{ mt: 2 }}>
            <Link to="/login">Volver al inicio de sesión</Link>
          </Typography>
        </Box>
      </div>
    </div>
  );
}

export default Confirmar;
